import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import Notes from 'modules/Notes';
import AllNotationCMSContainer from 'modules/Notes/components/AllNotationCMS';
import AllNotationTab from 'modules/Notes/components/AllNotationTab';
import FilterBloc from 'modules/Notes/components/AllNotes/FilterBloc';

import { getNotationRaw } from 'actions/notes';
import { useUserMe } from 'apiTyped/hooks/users.query';

const Container = styled.div`
  display: inline;

  .cardHeaderRight {
    max-height: 30px;
  }

  .rightComponentsContainer {
    display: flex;
  }

  .rightComponentsContainer > :not(:last-child) {
    margin: 0 10px 0 0;
  }
`;

class NotesAllNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wine: null,
      vintage: null,
      journal: null,
      degustateur: null,
      type: null,
      loading: true
    };
  }

  async componentDidMount() {
    await this.props.getNotationRaw();
    this.setState({ loading: false });
  }

  getOptions() {
    let data = this.props.data || [];
    const { journal } = this.state;

    const wineOptions = [...new Set(data.map((item) => item.wine_name))].map(
      (item) => ({
        value: item,
        label: item
      })
    );

    let journalOptions = [
      ...new Set(data.map((item) => item.journal_name))
    ].map((item) => ({
      value: item,
      label: item
    }));

    journalOptions = journalOptions.concat().sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });

    let vintageOptions = [...new Set(data.map((item) => item.vintage))]
      .sort()
      .map((item) => ({ value: item, label: item }));

    vintageOptions = vintageOptions.concat().sort(function (a, b) {
      return b.value - a.value;
    });

    const typeOption = [...new Set(data.map((item) => item.note_type))].map(
      (item) => ({
        value: item,
        label: item
      })
    );
    if (journal) {
      data = data.filter((item) => item.journal_name === journal);
    }
    const degustateurOption = [
      ...new Set(data.map((item) => item.degustateur_name))
    ]
      .sort()
      .map((item) => ({ value: item, label: item }));

    return {
      wine: wineOptions,
      journal: journalOptions,
      degustateur: degustateurOption,
      vintage: vintageOptions,
      type: typeOption
    };
  }

  filterData() {
    const data = this.props.data || [];
    const { wine, journal, degustateur, type, vintage, optionSearch } =
      this.state;

    let filteredData = [...data];
    if (optionSearch) {
      filteredData = filteredData.map((item) => ({
        ...item,
        wineVintage: `${item.wine_name} ${item.vintage}`,
        wineJournalist: `${item.wine_name} ${item.degustateur_name}`,
        wineJournal: `${item.wine_name} ${item.journal_name}`,
        vintageJournalist: `${item.degustateur_name} ${item.vintage}`
      }));
      filteredData = filteredData.filter((item) => {
        const valuesRow = Object.values(item);
        return valuesRow.includes(optionSearch.value);
      });
    } else {
      if (!wine && !journal && !degustateur && !type && !vintage) {
        return data.slice(0, 100);
      }
      filteredData = wine
        ? filteredData.filter((item) => item.wine_name === wine)
        : filteredData;
      filteredData = journal
        ? filteredData.filter((item) => item.journal_name === journal)
        : filteredData;
      filteredData = degustateur
        ? filteredData.filter((item) => item.degustateur_name === degustateur)
        : filteredData;
      filteredData = type
        ? filteredData.filter((item) => item.note_type === type)
        : filteredData;
      filteredData = vintage
        ? filteredData.filter((item) => item.vintage === vintage)
        : filteredData;
    }

    return filteredData;
  }

  getExportName() {
    return [
      this.state.wine,
      this.state.vintage,
      this.state.journal,
      this.state.degustateur,
      this.state.type,
      I18n.t('notes.allNotes.tableTitle')
    ]
      .filter((e) => e !== null)
      .join('-');
  }

  getOptionsSearch() {
    const data = this.props.data || [];
    let options = [];
    data.forEach((row) => {
      Object.keys(row).forEach((key) => {
        if (row[key] && key !== 'date' && key !== 'comment_filtered') {
          if (key === 'wine_name') {
            options.push(`${row.wine_name} ${row.degustateur_name}`);
            options.push(`${row.wine_name} ${row.journal_name}`);
          }
          if (key === 'vintage') {
            options.push(`${row.wine_name} ${row[key]}`);
            options.push(`${row.degustateur_name} ${row[key]}`);
          }
          options.push(row[key]);
        }
      });
    });
    options = [...new Set(options)];
    return options.map((item) => ({ value: item, label: item }));
  }

  render() {
    const options = this.getOptions();
    const optionsSearch = this.getOptionsSearch();
    const filteredData = this.filterData();

    const { user } = this.props;
    const { wine, vintage, journal, degustateur, type } = this.state;
    const hasWxrPanel = user.client.wxrPanels.length > 0;

    return (
      <Notes>
        <Container>
          <AllNotationCMSContainer admin={user.administrator} />
          <FilterBloc
            styles={``}
            options={options}
            hasWxrPanel={hasWxrPanel}
            values={this.state}
            onChange={(field, e) =>
              this.setState({ [field]: e?.value || null })
            }
            optionsSearch={optionsSearch}
          />
          <AllNotationTab
            data={filteredData}
            hasWxrPanel={hasWxrPanel}
            wine={wine}
            vintage={vintage}
            journal={journal}
            degustateur={degustateur}
            type={type}
            exportName={this.getExportName()}
            loading={this.state.loading}
          />
        </Container>
      </Notes>
    );
  }
}

const Index = ({ data, getNotationRaw }) => {
  const { user } = useUserMe();
  return (
    <NotesAllNotes user={user} data={data} getNotationRaw={getNotationRaw} />
  );
};

const mapStateToProps = (state) => ({
  data: state.notes.raw
});

const mapDispatchToProps = (dispatch) => ({
  getNotationRaw: async () => {
    await dispatch(getNotationRaw());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
